import { render } from "./Similars.vue?vue&type=template&id=781c0a45&scoped=true"
import script from "./Similars.vue?vue&type=script&lang=js"
export * from "./Similars.vue?vue&type=script&lang=js"

import "./Similars.vue?vue&type=style&index=0&id=781c0a45&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781c0a45"]])

export default __exports__